import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeInsert: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCodeInsert"><Path d="M13.5 4.5H2.5V19.5H13.5M15.5 4.5H21.5V19.5H15.5M15.5 4.5V2.5M15.5 4.5V19.5M15.5 19.5V21.5M9 9.5L11.5 12L9 14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCodeInsert;
